export default {
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
	KEEP_ALIVE: 'KEEP_ALIVE',
	INIT_USER_SETTINGS:'INIT_USER_SETTINGS'
}




// WEBPACK FOOTER //
// ./constants/auth.js